<template lang="pug">
    v-list-item-content.pa-0
        v-list-item-subtitle.text-center.cursor-default {{ conversation.friendly_created_at }}

        v-list.max-width-100-percent(v-if="!!conversation.messages && conversation.messages.length > 0")
            v-list-item.px-0.message-item(
                v-for='(message, j) in conversation.messages'
                :key='message.message_id'
                :data-message-id='message.message_id'
            ) 

                v-list-item-content(v-if="message.personable_type === 'customer_phone_number' && !message.is_message_undelivered")
                    div.d-flex.flex-row.align-center
                        Message(
                            :message="message"
                            :sender="message.personable_name"
                            :show-mark-as-read-icon="isLatestMessage(j) && isAcknowledgeable"
                            :is-update-communication-response-status-loading="isUpdateCommunicationResponseStatusLoading"
                            :update-communication-response-status-for-message-unresponded="updateCommunicationResponseStatusForMessageUnresponded"
                        )

                v-list-item-content.justify-content-flex-end(v-else-if="message.personable_type === 'twilio_number'")
                    Message(
                        :message="message"
                        :sender="message.user_full_name" 
                        right
                    )

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import Message from "@/components/communication_center/sms_message/message.vue"

    export default Vue.extend({
        methods: {
            isLatestMessage(index) {
                return this.isLatestConversation && index === this.conversation.messages.length - 1;
            }
        },
        components: {
            Message,
        },
        props: {
            conversation: Object,
            isLatestConversation: Boolean,
            isAcknowledgeable: Boolean,
            isUpdateCommunicationResponseStatusLoading: Boolean,
            updateCommunicationResponseStatusForMessageUnresponded: Function,
        },
    });
</script>

<style lang="scss" scoped>
</style>
